<template>
    <div>
        <header class="header">
            <div class="container clearfix">
                <div class="logo">
                    <a href="http://www.franklin.com.tw/" target="_blank" title="富蘭克林‧國民的基金">
                        <picture>
                            <source media="(max-width: 991px)" srcset="https://event.franklin.com.tw/commonResources/images/logo2019.svg">
                            <img src="https://event.franklin.com.tw/commonResources/images/header-logo.png" alt="富蘭克林‧國民的基金">
                        </picture>
                        <div class="logo-text">
                            富蘭克林‧國民的基金
                        </div>
                    </a>
                </div>
                <navbar :active-number="activeNumber" :navbar-show="navbarShow" v-if="false"></navbar>

                <!--手機menu按鍵-->
                <div class="menuBtn" data-wow-delay="0.8s" :class="{active: menuBtnActive}" @click="toggleMobileNavbar()" v-if="false">
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    </span>
                    <span>
                    </span>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

export default {
    props: ["activeNumber"],
    components: {
        Navbar
    },
    data() {
        return {
            menuBtnActive: false,
			navbarShow: false,
        }
    },
    methods: {
        toggleMobileNavbar() {
			this.menuBtnActive = !this.menuBtnActive;
			this.navbarShow = !this.navbarShow;
		},
		hideMobileNavbar() {
			this.menuBtnActive = false;
			this.navbarShow = false;
		},
    },
}
</script>